import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { SharedModule } from './../../../shared/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AddCourseComponent } from './add-course/add-course.component';
import { CourseEditorComponent } from './shared/course-editor/course-editor.component';
import { UpdateCourseComponent } from './update-course/update-course.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
  imports: [
    SharedModule, 
    RouterModule,
    MomentModule,
    NgxMaskDirective
  ],
  declarations:[ 
    AddCourseComponent,
    CourseEditorComponent, 
    UpdateCourseComponent
  ],
  exports:[],
  providers: [provideNgxMask()]
})
export class CoursesModule { }
